import React from 'react'

function ICICILombard() {
  return (
    <div>
      Lombard
    </div>
  )
}

export default ICICILombard;
